import React, { useEffect, useRef, useState } from "react";
import { ShimmerSocialPost, ShimmerThumbnail } from "react-shimmer-effects";
import axios from "../../API/axios";
import { post } from "../../assets/Images/ImagesLink";
import AddPost from "./AddPost";
import PostInteractionModal from "./PostInteractionModal";
import { Link } from "react-router-dom";
import ImageSliderModal from "./ImageSliderModal";
import Loading from "../Blogs/Loading";
import moment from "moment";
import PostEngagement from "./PostEngagement";
import PostComment from "./PostComment";
import SuccessToast from "../SuccessToast";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import Comment from "./Comment";
import LikesDetails from "./LikesDetails";
import { warning } from "framer-motion";
import {
  ShimmerCategoryItems,
  ShimmerDiv,
  ShimmerTitle,
} from "shimmer-effects-react";
import pin from "../../assets/Images/svg/pin.svg";
import PostComponent from "./PostComponent";
import InfoSharpIcon from "@mui/icons-material/InfoSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Advertisement from "./PostAdvertisement";
import ThumbUpSharpIcon from "@mui/icons-material/ThumbUpSharp";
import ArrowLeftSharpIcon from "@mui/icons-material/ArrowLeftSharp";
import ArrowRightSharpIcon from "@mui/icons-material/ArrowRightSharp";
import RecommendationAction from "../Connections/RecommendationAction";
import CompanyInteraction from "../Companies/CompanyInteraction";
// import BookmarkBorderSharpIcon from '@mui/icons-material/BookmarkBorderSharp';
// import BookmarkSharpIcon from '@mui/icons-material/BookmarkSharp';

const NewsfeedNew = () => {
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  const isDark = localStorage.getItem("isDark");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [postList, setPostList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isError, setIsError] = useState(false);
  const [dLike, setDLike] = useState(0);

  const userUid = localStorage.getItem("userUid");
  const [nextBatchLoading, setNextBatchLoading] = useState("");
  const [restrictedViewerToken, setRestrictedViewerToken] = useState('');

  const AllPostList = async (page) => {
    const data = {
      deviceType: "Web",
      pageNumber: page,
      pageSize: 6,
    };
    try {
      setLoading(true);
      setNextBatchLoading(true);
      const resData = await axios.post(`Feature/NewsFeeds`, data);
      setIsLoading(false);

      setTotalPages(resData.data.responseData.paging.totalPages);
      const newPosts = resData.data.responseData.dataList;

      setPostList((prev) => {
        const postSet = new Set(prev.map((post) => post.postInfo.postId));
        const uniqueNewPosts = newPosts.filter(
          (post) => !postSet.has(post.postInfo.postId)
        );
        setRestrictedViewerToken(resData?.data?.responseData?.restrictedViewerToken)
        return [...prev, ...uniqueNewPosts];
      });
      if (page >= resData.data.responseData.paging.totalPages) {
        setHasMoreData(false);
      }
      setNextBatchLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setIsError(true);
      } else {
        console.error(error);
      }
      // setIsLoading(false);
      setNextBatchLoading(false);
    }
  };
  
  // const AllPostList = async (page = 1, replace = false) => {
  //   const data = {
  //     deviceType: "Web",
  //     pageNumber: page,
  //     pageSize: 6,
  //   };
  //   try {
  //     setLoading(true);
  //     setNextBatchLoading(true);
  //     const resData = await axios.post(`Feature/NewsFeeds`, data);
  //     setIsLoading(false);
  
  //     setTotalPages(resData.data.responseData.paging.totalPages);
  //     const newPosts = resData.data.responseData.dataList;
  
  //     setPostList((prev) => {
  //       const postSet = new Set(prev.map((post) => post.postInfo.postId));
  //       const uniqueNewPosts = newPosts.filter(
  //         (post) => !postSet.has(post.postInfo.postId)
  //       );
  //       setRestrictedViewerToken(resData?.data?.responseData?.restrictedViewerToken);
  
  //       if (replace) {
  //         // REPLACE old list
  //         return uniqueNewPosts;
  //       } else {
  //         // APPEND to old list
  //         return [...prev, ...uniqueNewPosts];
  //       }
  //     });
  
  //     if (page >= resData.data.responseData.paging.totalPages) {
  //       setHasMoreData(false);
  //     }
  //     setNextBatchLoading(false);
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       setIsError(true);
  //     } else {
  //       console.error(error);
  //     }
  //     setNextBatchLoading(false);
  //   }
  // };
  
  const [hasMoreData, setHasMoreData] = useState(true);
  useEffect(() => {
    if (page <= totalPages) {
      AllPostList(page);
    }
  }, [page]);

  console.log("news feed consoling", postList);
  const getPostListWithAds = (posts) => {
    const result = [];
    posts.forEach((post, index) => {
      result.push(post);
      // Insert different components after every 12 posts
      if ((index + 1) % 6 === 0) {
        const pageIndex = Math.floor((index + 1) / 6);
        if (pageIndex % 2 === 1) {
          result.push({ isAd: true });
        } else if (pageIndex % 3 === 2) {
          result.push({ isPeopleRecommendation: true });
        } else if (pageIndex % 3 === 1) {
          result.push({ isJobRecommendation: true });
        } else if (pageIndex % 3 === 0) {
          result.push({ isCompanyRecommendation: true });
        }
      }
    });
    return result;
  };
  const postsWithAds = getPostListWithAds(postList);

  const handleInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, []);

  const updateLikeCount = (postId, delta) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postInfo.postId === postId
          ? {
            ...post,
            postInfo: {
              ...post.postInfo,
              likeCount: post.postInfo.likeCount + delta,
            },
          }
          : post
      )
    );
  };

  const updateCommentCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, commentCount: post.commentCount + change }
          : post
      )
    );
  };

  const updateShareCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postId === postId
          ? { ...post, shareCount: post.shareCount + change }
          : post
      )
    );
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [singlePostContent, setSinglePostContent] = useState("");
  const [singlepostId, setSinglePostId] = useState("");
  const [ispostmodalOpen, setIspostmodalOpen] = useState(false);

  const [sliderSettings, setSliderSettings] = useState({
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  });

  const [mediaFiles, setMediaFiles] = useState([]);
  const openModal = (mediaFiles, initialSlide) => {
    setSliderSettings((prevSettings) => ({
      ...prevSettings,
      initialSlide: initialSlide,
    }));
    setMediaFiles(mediaFiles);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [isfollowed, setIsfollowed] = useState(false);

  const [emojiList, setemojiList] = useState();
  const GetEmoji = async () => {
    try {
      await axios.get("Master/GetEmojiDDL").then((res) => {
        setemojiList(res.data.responseData);
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    GetEmoji();
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [postLikedType, setPostLikedType] = useState(false);
  const [postId, setPostId] = useState("");
  const [initialSlideIndex, setInitialSlideIndex] = useState(0);
  const [imageArray, setImageArray] = useState([]);

  const handleShowModal = (item) => {
    setPostId(item?.postInfo?.postId);
    setPostLikedType(item?.postInfo?.postActionsInfo?.likedType);
    setShowModal(true);
  };
  const handleLikesCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    scrollToTop();
  }, []);

  const [showDeletePost, setShowDeletePost] = useState(false);

  useEffect(() => {
    if (isModalOpen || showDeletePost) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [isModalOpen, showDeletePost]);
  const [userPer, setUserPer] = useState([]);
  const [alert, setAlert] = useState(false);
  const [isLoadingalert, setIsLoadingalert] = useState(true); // Add loading state

  const getUserProfilePer = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };
    axios
      .post(`UserProfile/GetProfilePercentage`, data)
      .then((response) => {
        const res = response.data.responseData;
        setUserPer(res.percentage);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoadingalert(false); // Set loading to false once the data is fetched
      });
  };

  useEffect(() => {
    getUserProfilePer();
  }, [sessionId]);

  const normalizedUserPer = Array.isArray(userPer)
    ? userPer.length === 0
      ? 0
      : Number(userPer[0])
    : Number(userPer);

  // Condition to show the alert
  const shouldShowAlert =
    !isLoadingalert &&
    normalizedUserPer <= 59 &&
    alert === false &&
    guestModeData === null;
  const [pr, setPR] = useState([]);
  const [jr, setJR] = useState([]);
  const [cr, setCR] = useState([]);

  const getPeopleRecommendation = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 12,
    };
    axios
      .post(`Feature/PeopleRecommendations`, data)
      .then((response) => {
        const res = response.data.responseData;
        setPR(res.dataList);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoadingalert(false); // Set loading to false once the data is fetched
      });
  };

  useEffect(() => {
    getPeopleRecommendation();
  }, []);
  const getJobRecommendation = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 12,
    };
    axios
      .post(`/Feature/JobRecommendations`, data)
      .then((response) => {
        const res = response.data.responseData;
        setJR(res.dataList);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoadingalert(false); // Set loading to false once the data is fetched
      });
  };

  useEffect(() => {
    getJobRecommendation();
  }, []);

  const getCompanyRecommendation = () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 12,
    };
    axios
      .post(`/Feature/CompanyRecommendations`, data)
      .then((response) => {
        const res = response.data.responseData;
        setCR(res.dataList);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoadingalert(false); // Set loading to false once the data is fetched
      });
  };

  useEffect(() => {
    getCompanyRecommendation();
  }, []);

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300; // Adjust scroll distance as needed
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const scrollRef1 = useRef(null);

  const scroll1 = (direction) => {
    if (scrollRef1.current) {
      const scrollAmount = 300; // Adjust scroll distance as needed
      scrollRef1.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const scrollRef2 = useRef(null);

  const scroll2 = (direction) => {
    if (scrollRef2.current) {
      const scrollAmount = 300; // Adjust scroll distance as needed
      scrollRef2.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const [recommendationList, setRecommendationList] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggleDropdown = (index) => {
    setShowDropdown((prev) => (prev === index ? null : index));
  };
  const [followedCompanies, setFollowedCompanies] = useState({});
  // const [checkApplied, setCheckApplied] = useState(isAppliedByYou);
  const [bookmarkModal, setBookmarkModal] = useState(false);
  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const handleShow = () => setShowAppliedModal(true);
  const handleCloseModal = () => setShowAppliedModal(false);
  const closeModalData = () => {
    setBookmarkModal(false);
  };
  const applyNew = async (jobId) => {
    try {
      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        jobId: jobId,
        type: 1,
        userUid: userUid,
      };
      const res = await axios.post("/JobAction/ApplyJob", body);
      setToastMessage(res.data.message);
      setShowToast(true);
      getJobRecommendation();
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.message);
        setShowErrorToast(true);
      }
    }
  };

  const [showResumeModal, setShowResumeModal] = useState(false);
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const userConfig = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };
    try {
      await axios.post("User/GetUserConfig", data).then((resData) => {
        // console.log('resData', resData.data.responseData);
        setProfileConfig(resData.data.responseData);
      });
    } catch (error) {
      if (
        (error.code === "ERR_NETWORK" && sessionId) ||
        (error.code === "ERR_BAD_REQUEST" && sessionId)
      ) {
        setUnauthorisedModal(true);
      }
    }
  };
  const [profileConfig, setProfileConfig] = useState([]);
  useEffect(() => {
    userConfig();
  }, []);

  //************************Save job End  ************************//
  const [savedJobs, setSavedJobs] = useState(new Set());
  const saveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
    };
    try {
      await axios.post(`JobAction/SaveJob`, responseData).then((res) => {
        console.log("save post", res);
        setToastMessage(res.data.message);
        setShowToast(true);
        setSavedJobs((prev) => new Set(prev).add(jobId));
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Save job End  ************************//

  //************************UnSave job start  ************************//
  const unsaveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
    };
    try {
      await axios.post(`JobAction/UnSaveJob`, responseData).then((res) => {
        // console.log(res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllJobList();
        // setIsSaved(false);
        setSavedJobs((prev) => {
          const newSavedJobs = new Set(prev);
          newSavedJobs.delete(jobId);
          return newSavedJobs;
        });
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************UnSave job End  ************************//
  console.log("postsWithAds", postsWithAds)
  return (
    <>
      <div className="row mt-3">
        <div className="col-md-8 newsfeedPosts">
          {shouldShowAlert && (
            <div className="p-3 closeAccount m-0 mb-3">
              <div className="d-flex mb-3 align-items-center">
                <InfoSharpIcon />
                <span className="cardHeader ms-1">Announcement!</span>
                <span className="ms-auto">
                  <CloseSharpIcon
                    style={{ width: "20px" }}
                    className="pointer"
                    onClick={() => setAlert(true)} // Dismiss the alert
                  />
                </span>
              </div>
              <div>
                <span>
                  Please complete your profile up to 60% and must have a valid
                  resume to apply for a job
                </span>
              </div>
              <div className="mt-2">
                <Link to={`/User/${userUid}`}>
                  <button
                    color=""
                    className="closebtn"
                    style={{ width: "150px" }}
                  >
                    Manage Profile
                  </button>
                </Link>
              </div>
            </div>
          )}
          <AddPost
            AllPostList={AllPostList}
            PostOriginType={"User"}
            postOriginId={userUid}
            setPostList={setPostList}
          />
          {isLoading ? (
            <div className="mt-3">
              <div className="shimmer-cont">
                <div className="shimmer-header d-flex">
                  <ShimmerDiv
                    mode="light"
                    height={60}
                    width={60}
                    rounded={50}
                  />
                  <div className="shimmer-title ms-3">
                    <ShimmerTitle mode="light" line={2} gap={8} />
                  </div>
                </div>
                <div className="square-shimmer mt-2">
                  <ShimmerDiv mode="light" height={100} width={100} />
                </div>
              </div>
            </div>
          ) : isError ? (
            <div className="mt-2 error-image-cont">
              <img src={post.errorbig} alt="404 Not Found" />
            </div>
          ) : (
            <>
              {postsWithAds
                ?.filter((item) => !item.isHidden)
                .map((item, index) => {
                  // console.log("resData", item.contentInfo);

                  return (
                    <React.Fragment key={`post-${index}`}>
                      {item.isAd && <Advertisement key={`ad-${index}`} />}
                      {item.isPeopleRecommendation && (
                        <div className="pr-container">
                          <h5>People Recommendation</h5>
                          <div className="pr-wrapper">
                            <button
                              className="scroll-btn left"
                              onClick={() => scroll("left")}
                            >
                              <ArrowLeftSharpIcon size={24} />
                            </button>
                            <div className="pr-scroll" ref={scrollRef}>
                              {pr.map((prItem) => (
                                <div className="pr-card" key={prItem.userUid}>
                                  <img
                                    src={prItem.profilPic}
                                    alt={prItem.fullName}
                                    className="pr-avatar"
                                  />
                                  <div className="pr-info mb-4">
                                    <h5>{prItem.fullName}</h5>
                                    <p className="pr-handle">
                                      {prItem.nameTag}
                                    </p>
                                    <p className="pr-title">{prItem.title}</p>
                                    <p className="pr-headline">
                                      {prItem.headLine}
                                    </p>
                                    <p className="pr-followers">
                                      {prItem.followersCount} Followers
                                    </p>
                                    {prItem.mutualUsers?.count > 0 && (
                                      <div className="pr-mutual">
                                        <p>{prItem.mutualUsers.text}</p>
                                        <div className="mutual-imgs">
                                          {prItem.mutualUsers.pics.map(
                                            (pic, idx) => (
                                              <img
                                                key={idx}
                                                src={pic}
                                                alt="Mutual Connection"
                                              />
                                            )
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  <div className="pr-action">
                                    <RecommendationAction
                                      item={prItem}
                                      GetRecommendation={
                                        getPeopleRecommendation
                                      }
                                      setRecommendationList={
                                        setRecommendationList
                                      }
                                      handleToggleDropdown={
                                        handleToggleDropdown
                                      }
                                      index={index}
                                      setShowDropdown={setShowDropdown}
                                      showDropdown={showDropdown}
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                            <button
                              className="scroll-btn right"
                              onClick={() => scroll("right")}
                            >
                              <ArrowRightSharpIcon size={24} />
                            </button>
                          </div>
                        </div>
                      )}

                      {item.isJobRecommendation && (
                        <div className="pr-container">
                          <h5>Job Recommendation</h5>
                          <button
                            className="scroll-btn left"
                            onClick={() => scroll1("left")}
                          >
                            <ArrowLeftSharpIcon size={24} />
                          </button>
                          <div className="pr-scroll" ref={scrollRef1}>
                            {jr.map((prItem) => (
                              <div className="pr-card" key={prItem.jobId}>
                                <img
                                  src={prItem.compLogo}
                                  alt={prItem.compName}
                                  className="pr-avatar"
                                />
                                <div className="pr-info">
                                  <h5>{prItem.compName}</h5>
                                  <p className="pr-handle">{prItem.cityName}</p>
                                  <p className="pr-title">{prItem.title}</p>
                                  <p className="pr-headline">
                                    {prItem.shortDescription}
                                  </p>
                                  <p className="pr-followers">
                                    {prItem.jobAppliedCount} Applicants
                                  </p>
                                  {prItem.applicantsInfo?.count > 0 && (
                                    <div className="pr-mutual">
                                      <p>{prItem.applicantsInfo.text}</p>
                                      <div className="mutual-imgs">
                                        {prItem.applicantsInfo.pics.map(
                                          (pic, idx) => (
                                            <img
                                              key={idx}
                                              src={pic}
                                              alt={`Applicant ${idx + 1}`}
                                            />
                                          )
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex justify-content-center align-items-center">
                                  {prItem?.isAppliedByYou === true ? (
                                    <button
                                      className="mainBtn  appliedBtn mt-4"
                                      style={{ width: "100px" }}
                                      onClick={() => {
                                        guestModeData === "true"
                                          ? setBookmarkModal(true)
                                          : handleShow();
                                        // setIsappliedF(false);
                                      }}
                                    >
                                      <span className="default-text">
                                        Applied
                                      </span>
                                      <span className="hover-text">
                                        Unapply
                                      </span>
                                    </button>
                                  ) : (
                                    <button
                                      className="mainBtn mt-4"
                                      style={{ padding: "5px" }}
                                      onClick={() =>
                                        guestModeData === "true"
                                          ? setBookmarkModal(true)
                                          : (profileConfig.hasCcv === null ||
                                            profileConfig.hasCcv === false) &&
                                            userPer?.percentage < 60
                                            ? setShowResumeModal(!showResumeModal)
                                            : applyNew(prItem?.jobId)
                                      }
                                    >
                                      Apply
                                    </button>
                                  )}
                                  {savedJobs.has(prItem?.jobId) ||
                                    prItem?.isSaved === true ? (
                                    <div className="d-flex align-items-center postAction mt-4 ms-2">
                                      <button
                                        className="mainBtn  appliedBtn"
                                        style={{ padding: "5px" }}
                                        onClick={() => {
                                          if (guestModeData !== "true") {
                                            unsaveJob(prItem?.jobId);
                                          }
                                        }}
                                      >
                                        Unsave
                                      </button>
                                    </div>
                                  ) : (
                                    <div className="d-flex align-items-center postAction mt-4 ms-2">
                                      <button
                                        className="mainBtn  appliedBtn"
                                        style={{ padding: "5px" }}
                                        onClick={() => {
                                          if (guestModeData !== "true") {
                                            saveJob(prItem?.jobId);
                                          }
                                        }}
                                      >
                                        save
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                          <button
                            className="scroll-btn right"
                            onClick={() => scroll1("right")}
                          >
                            <ArrowRightSharpIcon size={24} />
                          </button>
                        </div>
                      )}
                      {item.isCompanyRecommendation && (
                        <div className="pr-container">
                          <h5>Company Recommendation</h5>
                          <button
                            className="scroll-btn left"
                            onClick={() => scroll2("left")}
                          >
                            <ArrowLeftSharpIcon size={24} />
                          </button>
                          <div className="pr-scroll" ref={scrollRef2}>
                            {cr.map((prItem) => (
                              <div className="pr-card" key={prItem.companyUid}>
                                <img
                                  src={prItem.companyLogo}
                                  alt={prItem.companyName}
                                  className="pr-avatar"
                                />
                                <div className="pr-info">
                                  <h5>{prItem.companyName}</h5>
                                  <p className="pr-handle">{prItem.city}</p>
                                  <p className="pr-title">{prItem.title}</p>
                                  <p className="pr-followers">
                                    {prItem.followersCount} Followers
                                  </p>
                                  {prItem.networkFollowers?.count > 0 && (
                                    <div className="pr-mutual">
                                      <p>{prItem.networkFollowers.text}</p>
                                      <div className="mutual-imgs">
                                        {prItem.networkFollowers.pics.map(
                                          (pic, idx) => (
                                            <img
                                              key={idx}
                                              src={pic}
                                              alt={`Connection ${idx + 1}`}
                                            />
                                          )
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <CompanyInteraction
                                  item={prItem}
                                  isCompanyFollowed={prItem.isFollowedByYou}
                                  index={index}
                                  followedCompanies={followedCompanies}
                                  setFollowedCompanies={setFollowedCompanies}
                                  getCompanyList={getCompanyRecommendation}
                                />
                              </div>
                            ))}
                          </div>
                          <button
                            className="scroll-btn right"
                            onClick={() => scroll2("right")}
                          >
                            <ArrowRightSharpIcon size={24} />
                          </button>
                        </div>
                      )}
                      {!item.isAd &&
                        !item.isPeopleRecommendation &&
                        !item.isJobRecommendation &&
                        !item.isCompanyRecommendation && (
                          <div
                            className="featured-card user-postOnlyContent p-2 mb-3"
                            key={index}
                          >
                            {item?.isSuggested === true && (
                              <div
                                className={`postData d-flex align-items-center border-custom1 `}
                              >
                                <div className="thumb">
                                  <ThumbUpSharpIcon />
                                </div>
                                <div className="ms-2">
                                  <p className=" gradient-text">
                                    Suggested based on your network
                                  </p>
                                </div>
                              </div>
                            )}
                            {item?.contentInfo === null ? (
                              ""
                            ) : (
                              <div
                                className={`postData d-flex align-items-center border-custom1 `}
                              >
                                <div className="circle-container">
                                  {item?.contentInfo?.pics?.map((pic, idx) => (
                                    <>
                                      <img
                                        src={pic}
                                        alt={`Circle ${idx + 1}`}
                                        className="circle-img borderCircle"
                                        key={idx}
                                      />
                                    </>
                                  ))}
                                </div>
                                <div
                                  style={{
                                    marginLeft:
                                      item?.contentInfo?.count === 3
                                        ? "32px"
                                        : "10px",
                                  }}
                                >
                                  <p className="f-12">
                                    {item?.contentInfo?.text}
                                  </p>
                                </div>
                              </div>
                            )}

                            <div className="feature-content p-2 d-flex justify-content-between">
                              <Link
                                className="mb-1"
                                to={
                                  item?.postInfo?.postOriginType === "Company"
                                    ? `/Company/${item?.postInfo?.userUid}`
                                    : `/User/${item?.postInfo?.userUid}`
                                }
                              >
                                <div className="d-flex align-items-center">
                                  <div className="ImgAvatar">
                                    <img
                                      src={item?.postInfo?.userAvatar}
                                      alt=""
                                      style={{ borderRadius: "50px" }}
                                    />
                                  </div>

                                  <div className="ms-2 mb-2">
                                    <h4 className="f-14 fw-bold mb-0">
                                      {item?.postInfo?.userName}{" "}
                                    </h4>
                                    <p className="f-12">
                                      {item?.postInfo?.title}
                                    </p>
                                    <p className="f-12">
                                      {item?.postInfo?.additionalInfo}
                                    </p>
                                    <p className="f-10 label">
                                      {moment
                                        .utc(item?.postInfo?.creationTime)
                                        .local()
                                        .format("DD MMMM YYYY [at] h:mm a")}
                                    </p>
                                  </div>
                                </div>
                              </Link>

                              {guestModeData === "true" ? (
                                ""
                              ) : (
                                <div className="row">
                                  <div>
                                    <PostInteractionModal
                                      postId={item?.postInfo?.postId}
                                      AllPostList={AllPostList}
                                      postList={postList}
                                      setPage={setPage}
                                      setPostList={setPostList}
                                      page={page}
                                      setTotalPages={setTotalPages}
                                      totalPages={totalPages}
                                      item={item?.postInfo}
                                      PostOriginType={"User"}
                                      postOriginId={userUid}
                                      isfollowed={isfollowed}
                                      setIsfollowed={setIsfollowed}
                                      setShowDeletePost={setShowDeletePost}
                                      showDeletePost={showDeletePost}
                                      ispinned={item?.postInfo?.isPinned}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                            <PostComponent item={item} />

                            <div
                              className="feed-post"
                              style={{
                                paddingTop:
                                  item?.postInfo?.postMediaCount === 0
                                    ? "60px"
                                    : "4px",
                              }}
                            >
                              <div className="row">
                                {item?.postInfo?.mediaFilesList?.slice(0, 4)?.map(
                                  (file, idx) => (
                                    console.log("backimg", item.contentInfo),
                                    (
                                      <div
                                        key={idx}
                                        className={`col-${item?.postInfo.mediaFilesList
                                          .length === 1
                                          ? "12"
                                          : "6"
                                          } ${item?.postInfo.mediaFilesList
                                            .length === 3 && idx === 0
                                            ? "col-12"
                                            : ""
                                          }`}
                                        onClick={() => {
                                          setInitialSlideIndex(idx);
                                          setImageArray(
                                            item?.postInfo.mediaFilesList
                                          );
                                          console.warn(
                                            "===========1============>>",
                                            idx
                                          );
                                          let imageData =
                                            item?.postInfo.mediaFilesList.map(
                                              (file) => file.mediaName
                                            );
                                          openModal(imageData, idx);
                                          setSinglePostContent(item);
                                          setSinglePostId(
                                            item?.postInfo?.postId
                                          );
                                        }}
                                        style={{
                                          position: "relative",
                                          padding:
                                            item?.postInfo?.mediaFilesList
                                              .length === 3 && idx === 0
                                              ? "0 0 5px 0"
                                              : item?.postInfo?.mediaFilesList
                                                .length === 3 && idx === 1
                                                ? "0 5px 5px 0"
                                                : item?.postInfo?.mediaFilesList
                                                  .length === 4 && idx === 2
                                                  ? "0 5px 0 0"
                                                  : item?.postInfo?.mediaFilesList
                                                    .length === 4 && idx === 0
                                                    ? "0 5px 5px 0"
                                                    : item?.postInfo?.mediaFilesList
                                                      .length === 2 && idx === 0
                                                      ? "0 5px 5px 0"
                                                      : "",
                                        }}
                                      >
                                        {item?.cntntTypCategory !== 'TextWithVideo' || item?.cntntTypCategory !== 'Video' ? 
                                        <img
                                          src={file?.mediaName}
                                          alt=""
                                          className="img-fluid"
                                          width={"100%"}
                                        /> : null}
                                        {item?.cntntTypCategory === 'TextWithVideo' || item?.cntntTypCategory === 'Video' ? <div style={{ paddingBottom: '50px' }}>

                                          <iframe width="100%" height="300" 
                                          src={`https://www.videoindexer.ai/embed/player/3933d146-5f68-41d4-93a3-d2f7454d4a8d/${file?.mediaInfo}/?accessToken=${restrictedViewerToken}&location=centralindia&controls=true&autoplay=false`} frameborder="0" allowfullscreen allow="autoplay; fullscreen"
                                          ></iframe>
                                        </div> : null}

                                        {idx === 3 &&
                                          item?.postInfo.postMediaCount > 4 && (
                                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                              +
                                              {item?.postInfo.postMediaCount -
                                                4}
                                            </div>
                                          )}
                                      </div>
                                    )
                                  )
                                )}
                              </div>
                              {guestModeData === "true" ? (
                                ""
                              ) : (
                                <div className="row comment-gradient">
                                  <div
                                    className="addComment"
                                    onClick={() => {
                                      setInitialSlideIndex(1);
                                      setImageArray(
                                        item?.postInfo?.mediaFilesList
                                      );
                                      let imageData =
                                        item?.postInfo?.mediaFilesList?.map(
                                          (file) => file.mediaName
                                        );
                                      openModal(imageData, 1);
                                      setSinglePostContent(item);
                                      setSinglePostId(item?.postInfo?.postId);
                                    }}
                                  >
                                    <div
                                      className="postCommentWrapper"
                                      onClick={(event) =>
                                        event.stopPropagation()
                                      }
                                    >
                                      <PostComment
                                        item={item?.postInfo}
                                        postId={item?.postInfo?.postId}
                                        AllPostList={AllPostList}
                                        postList={postList}
                                        setPage={setPage}
                                        setPostList={setPostList}
                                        page={page}
                                        setTotalPages={setTotalPages}
                                        totalPages={totalPages}
                                        updateCommentCount={updateCommentCount}
                                        ispostmodalOpen={ispostmodalOpen}
                                        setIspostmodalOpen={setIspostmodalOpen}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            <div
                              className={`postData d-flex align-items-center ${item?.postInfo?.likeCount === 0 &&
                                item?.postInfo?.commentCount === 0 &&
                                item?.postInfo?.shareCount === 0
                                ? ""
                                : "border-custom1"
                                }`}
                            >
                              <div className="circle-container">
                                {item?.postInfo?.postReactionContent?.pics?.map(
                                  (pic, idx) => (
                                    <>
                                      <img
                                        src={pic}
                                        alt={`Circle ${idx + 1}`}
                                        className="circle-img borderCircle"
                                        key={idx}
                                      />
                                    </>
                                  )
                                )}
                              </div>
                              <div
                                style={{
                                  marginLeft:
                                    item?.contentInfo?.count === 3
                                      ? "32px"
                                      : "10px",
                                }}
                              >
                                {item?.postInfo?.likeCount === 0 ? (
                                  ""
                                ) : (
                                  <p
                                    className="f-10 like-details"
                                    onClick={() => handleShowModal(item)}
                                  >
                                    {item?.postInfo?.postReactionContent?.text}{" "}
                                    {item?.postInfo?.likeCount} likes
                                  </p>
                                )}
                              </div>
                              <div className="ms-auto d-flex">
                                {item?.postInfo?.commentCount === 0 ? (
                                  ""
                                ) : (
                                  <p
                                    className="f-10 me-2 pointer"
                                    onClick={() => {
                                      openModal(
                                        item?.postInfo.mediaFilesList.map(
                                          (file) => file.mediaName
                                        )
                                      );
                                      setSinglePostContent(item);
                                      setSinglePostId(item?.postInfo?.postId);
                                    }}
                                  >
                                    {" "}
                                    {item?.postInfo?.commentCount} comments{" "}
                                  </p>
                                )}

                                <p className="f-10">
                                  {item?.postInfo?.shareCount === 0
                                    ? ""
                                    : `&  ${item?.postInfo?.shareCount} Shares`}
                                </p>
                              </div>
                            </div>
                            <div className="postengagement">
                              <PostEngagement
                                item={item}
                                postId={item?.postInfo?.postId}
                                AllPostList={AllPostList}
                                postList={postList}
                                setPage={setPage}
                                setPostList={setPostList}
                                page={page}
                                setTotalPages={setTotalPages}
                                totalPages={totalPages}
                                updateLikeCount={updateLikeCount}
                                updateShareCount={updateShareCount}
                                openModal={openModal}
                                setSinglePostContent={setSinglePostContent}
                                setSinglePostId={setSinglePostId}
                                ispostmodalOpen={ispostmodalOpen}
                                setIspostmodalOpen={setIspostmodalOpen}
                                emojiList={emojiList}
                              />
                            </div>
                            {console.log("responseData", item)}
                            <Comment
                              item={item}
                              isOwnedPost={item?.postInfo?.isOwned}
                              postId={item?.postInfo?.postId}
                              AllPostList={AllPostList}
                              postList={postList}
                              setPage={setPage}
                              setPostList={setPostList}
                              page={page}
                              setTotalPages={setTotalPages}
                              totalPages={totalPages}
                              emojiList={emojiList}
                            />
                          </div>
                        )}
                    </React.Fragment>
                  );
                })}
            </>
          )}
          {hasMoreData ? (
            ""
          ) : (
            <p className="text-center">No more data available</p>
          )}
          {nextBatchLoading && (
            <div className="text-center">
              <img src={post?.loader} width={50} />
            </div>
          )}
        </div>
      </div>

      {isModalOpen && (
        <ImageSliderModal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          images={modalImages}
          item={singlePostContent}
          singlepostId={singlepostId}
          setSinglePostId={setSinglePostId}
          updateShareCount={updateShareCount}
          updateLikeCount={updateLikeCount}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          page={page}
          setPostList={setPostList}
          setPage={setPage}
          postList={postList}
          AllPostList={AllPostList}
          PostEngagement={PostEngagement}
          dLike={dLike}
          updateCommentCount={updateCommentCount}
          ispostmodalOpen={ispostmodalOpen}
          setIspostmodalOpen={setIspostmodalOpen}
          openModal={openModal}
          setSinglePostContent={setSinglePostContent}
          setDLike={setDLike}
          setShowModal={showModal}
          handleLikesCloseModal={handleLikesCloseModal}
          isfollowed={isfollowed}
          setIsfollowed={setIsfollowed}
          initialSlideIndex={initialSlideIndex}
          setInitialSlideIndex={setInitialSlideIndex}
          imageArray={imageArray}
          restrictedViewerToken={restrictedViewerToken}
        />
      )}
      {/* {showModal &&  */}
      <LikesDetails
        showModal={showModal}
        handleLikesCloseModal={handleLikesCloseModal}
        postId={postId}
        postLikedType={postLikedType}
      />
      {/* } */}

      {loading && (
        <div className="row">
          <div className="col-md-12">
            <Loading />
          </div>
        </div>
      )}
      {showToast && (
        <SuccessToast
          show={showToast}
          message={toastMessage}
          onClose={() => setShowToast(false)}
        />
      )}

      {showWarningToast && (
        <WarningToast
          show={showWarningToast}
          message={warningToastMessage}
          onClose={() => setShowWarningToast(false)}
        />
      )}
      {showErrorToast && (
        <ErrorToast
          show={showErrorToast}
          message={ErrorToastMessage}
          onClose={() => setShowErrorToast(false)}
        />
      )}
    </>
  );
};

export default NewsfeedNew;
